export class AccountHeadRequest {
    constructor(public accountNumber?: string,
        public bank?: boolean,
        public parent?: boolean,
        public id?: number,
        public name?: string,
        public accountTypeId?: number,
        public parentId?: number,
        public prevParentId?: number,
        public isParent?: boolean,
        public rootId?: number,
        public displayOrder?: number) { }
}
